import React from 'react';
import clsx from 'clsx';
import TrustTag from './TrustTag';
import EvidenceToggle from './EvidenceToggle';

/**
 * One message bubble. User messages align right, assistant messages left.
 * Assistant messages carry the trust tag and evidence toggle.
 */

export default function Message({ message }) {
  const isUser = message.role === 'user';
  const isAssistant = message.role === 'assistant';
  const isPending = message.pending;

  return (
    <div
      data-drishti="message"
      data-role={message.role}
      className={clsx('flex', isUser ? 'justify-end' : 'justify-start')}
    >
      <div
        className={clsx(
          'max-w-[85%] px-4 py-3',
          isUser
            ? 'rounded-[20px] rounded-br-md bg-navy text-white shadow-[0_4px_12px_rgba(6,43,85,0.25)]'
            : 'rounded-[20px] rounded-bl-md border border-app-border/80 bg-white text-slate-800 shadow-[0_2px_8px_rgba(15,23,42,0.04)]',
        )}
      >
        {isAssistant && !isPending ? (
          <div className="mb-2">
            <TrustTag tag={message.tag} />
          </div>
        ) : null}

        {isPending ? (
          <PendingDots />
        ) : (
          <div className={clsx('whitespace-pre-wrap text-sm leading-relaxed', message.errored && 'text-error')}>
            {message.text}
          </div>
        )}

        {isAssistant && !isPending && message.evidence ? (
          <EvidenceToggle evidence={message.evidence} />
        ) : null}
      </div>
    </div>
  );
}

function PendingDots() {
  return (
    <div
      role="status"
      aria-label="Drishti is thinking"
      className="flex items-center gap-1"
    >
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-slate-400" />
      <span
        className="h-1.5 w-1.5 animate-pulse rounded-full bg-slate-400"
        style={{ animationDelay: '150ms' }}
      />
      <span
        className="h-1.5 w-1.5 animate-pulse rounded-full bg-slate-400"
        style={{ animationDelay: '300ms' }}
      />
    </div>
  );
}
